var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid regulatory-updates-sub-menu" },
    [
      _c("div", { staticClass: "col-xs-12 p-0 mt-25 mb-20" }, [
        _c(
          "div",
          {
            staticClass:
              "page-header-title col-xs-12 col-sm-4 col-md-5 p-0 col-lg-6",
          },
          [_vm._v("Regulatory Watch")]
        ),
        _c(
          "div",
          {
            staticClass:
              "col-xs-12 col-sm-8 col-md-7 col-lg-6 p-0 d-flex-sm-end xs-mt-20",
          },
          [
            _vm.permissions.includes("REG_WTCH_REG_UPD_SEARCH_FOR_UPDATE")
              ? _c(
                  "div",
                  { staticClass: "search-container flex-50" },
                  [
                    _c("search-box", {
                      on: {
                        getList: function ($event) {
                          return _vm.searchReg()
                        },
                      },
                      model: {
                        value: _vm.searchRegulatory,
                        callback: function ($$v) {
                          _vm.searchRegulatory = $$v
                        },
                        expression: "searchRegulatory",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.permissions.includes("REG_WTCH_REG_UPD_PREFERENCES")
              ? _c(
                  "div",
                  { staticClass: "heading-sub-menu" },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "btn emergo-blue-button",
                        on: { click: _vm.OpenRegWatchSettings },
                      },
                      [_vm._v("Manage Countries")]
                    ),
                    _c(
                      "el-popover",
                      {
                        staticClass: "ml-10 width-400 width-300",
                        attrs: {
                          placement: "top-start",
                          trigger: "click",
                          width: "310",
                        },
                        on: {
                          show: function ($event) {
                            _vm.infoActive = true
                          },
                          hide: function ($event) {
                            _vm.infoActive = false
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "limit_popover_txt" }, [
                          _vm._v(" Regulatory updates are displayed based on "),
                          _c("br"),
                          _vm._v("countries selected under Account Settings."),
                          _c("br"),
                          _vm._v("See all countries or customize based on"),
                          _c("br"),
                          _vm._v("your market interest. "),
                        ]),
                        !_vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon.svg",
                                alt: "info-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                        _vm.infoActive
                          ? _c("img", {
                              staticClass: "info-img",
                              attrs: {
                                slot: "reference",
                                src: "/static/images/icons/info_icon_active.svg",
                                alt: "infoactive-icon",
                              },
                              slot: "reference",
                            })
                          : _vm._e(),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]),
      _vm.searchRegResultCount.length > 0 || this.isFromGlobalSearch
        ? _c(
            "div",
            { staticClass: "col-xs-12 regulatory-label new-count-pl" },
            [
              _c("p", [
                _vm._v(
                  _vm._s(_vm.filteredRegulatoryLength) + " Result(s) found..."
                ),
              ]),
            ]
          )
        : _vm._e(),
      _c("div", { staticClass: "col-xs-12 new-count-pl pb-20" }, [
        _vm.permissions.includes("REG_WTCH_REG_UPD_NEW")
          ? _c(
              "div",
              {
                staticClass: "col-xs-12 col-sm-8 col-lg-9 p-0 heading-sub-menu",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.headerValues.newCount) +
                    " New Regulatory Updates "
                ),
              ]
            )
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }